"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIE = void 0;
var ua = window.navigator.userAgent;
exports.isIE = ua.indexOf("MSIE") >= 0 || ua.indexOf('Trident') >= 0;
if (exports.isIE)
    console.warn('IE detected, Swiper and some other features disabled.');
